module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box__header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-effd3c22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Box/BoxHeader.vue
// module id = 1720
// module chunks = 2